import { Button } from '@cian/ui-kit';
import { IconFilePrint16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ModalPrintContainer } from './ModalPrintContainer';
import { trackPrintConfirm } from './tracking';
import { closeModal, openModal } from '../../../actions/print';
import { selectIsModalOpen, selectOptions } from '../../../selectors/print';
import { selectSelectedProducts } from '../../../selectors/selected';
import { trackPrintAllClick } from '../../TopBar';

export function PrintContainer() {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(selectIsModalOpen);
  const options = useSelector(selectOptions);
  const selectedProducts = useSelector(selectSelectedProducts);

  const [print, setPrint] = React.useState(false);

  const handlePrintClick = () => {
    trackPrintAllClick();
    setPrint(false);
    dispatch(openModal());
  };

  const handleConfirmPrint = () => {
    trackPrintConfirm(selectedProducts, options);
    dispatch(closeModal());
    setPrint(true);
  };

  // нужно для синхронного вызова диалога печати после закрытия модалки "Распечатать"
  React.useEffect(() => {
    if (print) {
      window.print();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen]);

  return (
    <>
      {isModalOpen && <ModalPrintContainer onConfirm={handleConfirmPrint} />}
      <Button
        beforeIcon={<IconFilePrint16 color="icon-main-default" />}
        size="XS"
        theme="fill_white_primary"
        onClick={handlePrintClick}
      >
        Печатать
      </Button>
    </>
  );
}
